import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {TOC} from './TOC';
import {CustomComponent, Link} from '../../common/components';
import {ToggleMenu} from '../../common/components/ToggleMenu';

import './NavBar.scss';
import '~/assets/scss/transformicons.scss';


export class NavMenu extends CustomComponent {
    render() {
        return (
            <div className="animated NavMenu">
                {this.props.tocSections &&
                    <TOC type="navbar" pageLabelPrefix={this.props.pageLabelPrefix} tocSections={this.props.tocSections} hash={this.props.hash}/>
                }
            </div>
        );
    }
}

export class NavBar extends CustomComponent {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
    }

    render() {
        const pageLabelPrefix = (this.props.pageLabelPrefix ? this.props.pageLabelPrefix : 'api-other');
        return (
            <nav className="NavBar">
                <div className="container">
                    <span className="logo-buttons" itemScope={true} itemType="http://schema.org/Organization">
                        <Link to={'/'} className="navbar-brand">
                            <img src="/assets/img/tenor-logo-white.svg" width="80" height="22" alt="Tenor"/>
                        </Link>
                        <Link to={'https://developers.google.com/tenor/guides/quickstart'} className="navbar-brand-text">
                            <div>API</div>
                        </Link>
                    </span>
                    <div className="nav-buttons">
                        <Link to={'https://developers.google.com/tenor/guides/quickstart'}
                            className="white-button"
                            clickLabel={`${pageLabelPrefix}-developer-dashboard`}>
                            Documentation
                        </Link>
                        <ToggleMenu
                            buttonClassName="menu-button mobile-only navicon-button x"
                            menu={ <NavMenu
                                pageLabelPrefix={ pageLabelPrefix }
                                tocSections={ this.props.tocSections }
                                hash={ this.props.hash }/> }
                            closeOnScroll={true}
                        >
                            <div class="navicon"></div>
                        </ToggleMenu>
                    </div>
                </div>
            </nav>
        );
    }
}
